import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useAllEmployees } from '~/data/employees';
import { useAllOrgUnits } from '~/data/orgunits';
import { EmployeeActivityLog } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog';
import { useSxStyles } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/useStyles';

export type EmployeeActivityLogDialogProps = {
  employeeId: number;
  open: boolean;
  onClose: () => void;
};
export const EmployeeActivityLogDialog = ({
  open,
  onClose,
  employeeId,
}: EmployeeActivityLogDialogProps) => {
  const { t } = useTranslation();

  const sxStyles = useSxStyles();

  const { getEmployeeById } = useAllEmployees();
  const { getUnitByIdIncludeDeleted } = useAllOrgUnits();

  const { employeeFullName, unitName } = useMemo(() => {
    const employee = getEmployeeById(employeeId);
    const unit = getUnitByIdIncludeDeleted(employee?.fEmpUnit);

    const employeeFullName = !!employee
      ? `${employee.fEmpFirstName} ${employee.fEmpLastName}`
      : '';
    const unitName = !!unit ? unit.fOrgUnitName : '';

    return {
      employeeFullName,
      unitName,
    };
  }, [employeeId, getEmployeeById, getUnitByIdIncludeDeleted]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth={'xl'}
      slotProps={{
        paper: {
          sx: {
            minHeight: '90%',
            maxHeight: '90%',
          },
        },
      }}
    >
      <SolaForceDialogTitle onClose={onClose}>
        {`${t('userActivityLog')}: ${employeeFullName}`}
        <Box sx={sxStyles.titleUnitName}>{unitName}</Box>
      </SolaForceDialogTitle>
      <DialogContent dividers={true} sx={{ display: 'grid', padding: 0 }}>
        <EmployeeActivityLog employeeId={employeeId} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
